import { defineComponent as _defineComponent } from 'vue'
import { IProductHero } from '@/modules/catalog/services/products';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseIcon,
  BaseText,
  ButtonIconContextual,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { onBeforeUnmount, PropType, ref, watch } from 'vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetBar',
  props: {
  showHeaderText: Boolean,
  color: {
    type: String,
    default: ''
  },
  hero: {
    type: Object as PropType<IProductHero>,
    default: null
  },
  stopInvestmentBarOpen: Boolean
},
  emits: ['close', 'close-stop-investment-bar'],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();




const timeoutId = ref<ReturnType<typeof setTimeout> | null>(null);

const handleRegulatoryLinkClick = () => {
  router.push({ name: 'regulatoryUpdateAnnouncement' });
};

watch(
  () => props.stopInvestmentBarOpen,
  newValue => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
    }

    if (newValue) {
      timeoutId.value = setTimeout(() => {
        emit('close-stop-investment-bar');
      }, 6000);
    }
  }
);

onBeforeUnmount(() => {
  if (timeoutId.value) {
    clearTimeout(timeoutId.value);
  }
});

return { __sfc: true,router, props, emit, timeoutId, handleRegulatoryLinkClick, NebraskaColors, BaseIcon, BaseText, ButtonIconContextual, NavBar }
}

})